import React from 'react';
import BaseContainer from '../../../Packages/block-container';
import { useCurrentBlockId } from '../../editor/EditorBlock';
import { setDocument, setSelectedBlockId, useDocument } from '../../editor/EditorContext';
import EditorChildrenIds from '../helpers/EditorChildrenIds';
export default function ContainerEditor({ style, props }) {
    var _e;
    const childrenIds = (_e = props === null || props === void 0 ? void 0 : props.childrenIds) !== null && _e !== void 0 ? _e : [];
    const document = useDocument();
    const currentBlockId = useCurrentBlockId();
    return (React.createElement(BaseContainer.Component, { style: style },
        React.createElement(EditorChildrenIds, { childrenIds: childrenIds, onChange: ({ block, blockId, childrenIds }) => {
                setDocument({
                    [blockId]: block,
                    [currentBlockId]: {
                        type: 'Container',
                        data: Object.assign(Object.assign({}, document[currentBlockId].data), { props: { childrenIds: childrenIds } }),
                    },
                });
                setSelectedBlockId(blockId);
            } })));
}
//# sourceMappingURL=ContainerEditor.js.map